import { cn } from "@omni/utils/styles";
import { useEffect } from "react";

import { useStoreServiceApi } from "@/api/hooks/storeService.hook";
import { EcornerService } from "@/services/eCorner.service";

import { ProductFacing } from "./productFacing.component";

type Props = {
    sku: string;
    className?: string;
};

const ProductFacingContainer = ({ sku, className }: Props) => {
    const [{ data, loading, error }, get] = useStoreServiceApi(
        {
            method: "GET"
        },
        {
            manual: true
        }
    );

    useEffect(() => {
        if (data) return;
        if (loading) return;
        if (error) return;

        if (EcornerService.isEcornerEnvironment()) {
            const { url, urlParams } = EcornerService.getEcornerUrl(sku);

            if (url && urlParams) {
                get({
                    url,
                    urlParams
                });
            }
        }
    }, [sku, data, loading, error, get]);

    if (!data) {
        return null;
    }

    return (
        <ProductFacing
            layer={data.layer}
            subFacingName={data.subFacingName}
            name={data.name}
            position={data.position}
            amountOfPositions={data.amountOfPositions}
            className={cn(className)}
        />
    );
};

export { ProductFacingContainer };
